import { CardDescription } from 'src/shared/components/ui/cards/card'
import { cn } from 'src/shared/utils/cn'

const AuthSubtitle = ({ description, className }: { description: string; className?: string }) => {
  return (
    <CardDescription className={cn('mb-6 text-center text-[15px] text-muted xs:text-[16px]', className)}>
      {description}
    </CardDescription>
  )
}

export default AuthSubtitle
